export default "__VITE_ASSET__BMIhNXnP__"